import { AppRoutes } from "../../../common/routes/app_routes";

export function getQuotationCheckoutUrl(saleId: number): string {
  return `${AppRoutes.CHECKOUT}?saleId=${saleId}&step=payment`;
}
